import { Col } from 'antd'
import React, { FunctionComponent, memo } from 'react'

import { useFinancingStatus } from '../../utils/useFinancingStatus'

export interface BuybackFormSummaryFragmentStatusProps {
  onClick: () => void
}

export const BuybackFormSummaryFragmentStatus: FunctionComponent<BuybackFormSummaryFragmentStatusProps> =
  memo(({ onClick }) => {
    const status = useFinancingStatus()
    return (
      <Col xs={24} md={12} xl={8} className="text-center">
        <div className="mb-2">Ověření dostupnosti financování</div>
        <div
          className="text-2xl cursor-pointer hover:opacity-70 transition-opacity"
          onClick={onClick}
        >
          <span className={'uppercase font-semibold ' + status.className}>
            {status.text}
          </span>
        </div>
      </Col>
    )
  })
